export const environment = {
    name: 'production',
    production: true,
    testing: false,
    enableServiceWorker: true,
    allowSearchEngines: true,
    showPanics: false,
    accountsUrl: 'https://accounts.tyt.com',
    platformUrl: 'https://platform.tyt.com',
    spotId: 'sp_s81DnEgR',
    showDevTools: false,
    recaptchaV2SiteKey: '6LfORrIZAAAAADh6jtBF5aMhuEc3XfLjN4wBwepR',
    recaptchaV3SiteKey: '6LfsRbIZAAAAAMcH0NLIDxSqvJy3JNUs3XpWxQ4L',
    bugsnagKey: '100b690374ca57ef9bc9b16b1dd9c08a'
}